import React from 'react';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Image from 'components_v2/common/ImageV2';

class ReadAlsoWidgetLinks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isThumbImg: false,
    };
  }
  componentDidMount() {
    this.setState({
      isThumbImg: true,
    });
  }
  handleError = () => {
    this.setState({
      isThumbImg: false,
    });
  };

  getLinkHTML = item => {
    let linkContainingHTML = '';
    let thumbImgHTML = '';
    const s = this.props.styleObj;
    const { isWapView } = this.props;
    const { msid, value, syn } = item;
    if (!isWapView && syn) {
      linkContainingHTML = (
        <div className={s.details}>
          <span>{value}</span>
          <p className={s.synopsis}>{syn}</p>
        </div>
      );
    } else {
      linkContainingHTML = <span>{value}</span>;
    }
    if (this.state.isThumbImg) {
      thumbImgHTML = (
        <Image
          onError={this.handleError}
          placeHolderSrc="https://static.toiimg.com/photo/34824568.cms"
          offsetVertical={300}
          width={200}
          msid={msid}
          alt={value}
          lazyload
        />
      );
    }
    linkContainingHTML = [linkContainingHTML, thumbImgHTML];
    return linkContainingHTML;
  };

  render() {
    const {
      item,
      readMoreGA,
      index,
      numberOfArticles,
      showMore,
      countReadAlso,
    } = this.props;
    const s = this.props.styleObj;
    return (
      <Link
        to={item.su}
        spa={item.isspa}
        data-ga={
          item.su
            ? `${readMoreGA}_Story-${countReadAlso || index + 1}-${item.su}`
            : readMoreGA
        }
        className={showMore && index >= numberOfArticles ? s.hideArticle : ''}
        onClick={() => {
          if (this.props.ga4Object) {
            analyticsWrapper('ga4', {
              ...this.props.ga4Object,
              story_no: index + 1,
            });
          }
        }}
      >
        {this.getLinkHTML(item)}
      </Link>
    );
  }
}
ReadAlsoWidgetLinks.propTypes = {
  item: PropTypes.shape({
    msid: PropTypes.string,
    value: PropTypes.string,
    su: PropTypes.string,
    isspa: PropTypes.bool,
    img: PropTypes.string,
    tags: PropTypes.string,
    syn: PropTypes.string,
  }).isRequired,
  readMoreGA: PropTypes.string,
  isWapView: PropTypes.bool,
  styleObj: PropTypes.string.isRequired,
  numberOfArticles: PropTypes.number,
  showMore: PropTypes.bool,
  index: PropTypes.number,
  countReadAlso: PropTypes.string,
  ga4Object: PropTypes.shape({}),
};

ReadAlsoWidgetLinks.defaultProps = {
  isWapView: false,
  numberOfArticles: 4,
  readMoreGA: '',
  showMore: false,
  index: 0,
  countReadAlso: '',
  ga4Object: undefined,
};

export default ReadAlsoWidgetLinks;
